import React from 'react';
import { Tooltip, Typography } from 'antd';
import styled from '@emotion/styled';
import { BenefitType } from '../../../../types/benefit';

interface ColumnProps {
  record: BenefitType;
}

export default React.memo((props: ColumnProps) => {
  const { record } = props;

  return (
    <StyledPartnerContainer>
      <Tooltip placement="topLeft" title={record?.partner?.title}>
        <Typography.Text>{record?.partner?.title}</Typography.Text>
      </Tooltip>
    </StyledPartnerContainer>
  );
});

const StyledPartnerContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: center;
  justify-content: center;

  .ant-typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
